import { Icon, Modal, Tooltip } from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next'
import ReactPlayer from 'react-player'

function MediaPreview(props) {
  const { media, types, onClearMedia, isAudio } = props

  const mediaType = media && media.type

  const isVideo = mediaType === types.video
  const isImage = mediaType === types.image

  const { t } = useTranslation()
  const handleRemoveMedia = () => {
    Modal.confirm({
      title: t('v5:are_you_sure_you_want_to_remove_this_media'),
      content: t('v5:the_media_will_be_removed_from_the_scenario'),
      onOk() {
        onClearMedia()
      },
      centered: true,
      okText: t('v4:ok'),
      cancelText: t('v4:cancel')
    })
  }

  return (
    <div className={`media-preview-container ${isAudio ? 'audio' : ''}`}>
      {isAudio && (
        <audio controls>
          <source src={media.link} type="audio/mpeg" />
        </audio>
      )}

      {isVideo && (
        <ReactPlayer
          className="react-player"
          responsive
          width="100%"
          url={media.link}
          controls
          loop
          playing
        />
      )}

      {isImage && <img src={media.link} alt="" />}

      <Tooltip title="Remove Media">
        <Icon
          className="media-preview__close-btn"
          onClick={handleRemoveMedia}
          type="close"
        />
      </Tooltip>
    </div>
  )
}

export default MediaPreview
